import React, { useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

import LetterHead from '../components/documentTemplates/LetterHead';
import COI from '../components/documentTemplates/COI';
import MOA from '../components/documentTemplates/MOA';
import AOA from '../components/documentTemplates/AOA';
import BoardResolution from '../components/documentTemplates/BoardResolution';

function Template() {
    const [activeTemplate, setActiveTemplate] = useState('letter_head');
    const componentRef = useRef();

    const templates = [
        { id: 'letter_head', name: 'Letter Head', component: <LetterHead ref={componentRef} /> },
        { id: 'coi', name: 'Certificate of Incorporation', component: <COI ref={componentRef} /> },
        { id: 'moa', name: 'Memorandum of Association', component: <MOA ref={componentRef} /> },
        { id: 'aoa', name: 'Articles of Association', component: <AOA ref={componentRef} /> },
        { id: 'board_resolution', name: 'Board Resolution', component: <BoardResolution ref={componentRef} /> }
    ];

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: activeTemplate, // file name
    });

    const ActiveComponent = templates.find(t => t.id === activeTemplate)?.component;

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Navigation */}
            <nav className="bg-white shadow-lg">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16">
                        <div className="flex items-center">
                            <h1 className="text-xl font-bold text-gray-800">Company Documents</h1>
                        </div>
                        <div className="hidden md:flex md:space-x-8">
                            {templates.map((template) => (
                                <button
                                    key={template.id}
                                    onClick={() => setActiveTemplate(template.id)}
                                    className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${activeTemplate === template.id
                                        ? 'border-blue-500 text-gray-900'
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                                        }`}
                                >
                                    {template.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </nav>

            {/* Main content */}
            <main className="p-4">
                <div ref={componentRef}>
                    {ActiveComponent}
                </div>
            </main>
        </div>
    );
}

export default Template;
